document.addEventListener('DOMContentLoaded', function () {
  let initialized = false;

  function initFooterAccordion() {
    if (window.innerWidth <= 768 && !initialized) {
      initialized = true;

      const footerHeadings = document.querySelectorAll('.footer-block__heading');

      footerHeadings.forEach(heading => {
        if (heading.closest('.footer-block__newsletter')) {
          return; // пропускаємо newsletter
        }

        // Універсальна подія: працює і на touch, і на мишці
        ['click', 'touchend'].forEach(eventType => {
          heading.addEventListener(eventType, function (e) {
            e.preventDefault();

            this.classList.toggle('active');

            const detailsContent = this.nextElementSibling;
            if (detailsContent && detailsContent.classList.contains('footer-block__details-content')) {
              detailsContent.classList.toggle('active');
            }
          }, { passive: false });
        });
      });
    }

    // Якщо екран став >768px, скидаємо ініціалізацію
    if (window.innerWidth > 768 && initialized) {
      initialized = false;
    }
  }

  // Виклик під час завантаження
  initFooterAccordion();

  // На зміну розміру екрану
  window.addEventListener('resize', initFooterAccordion);
});
